import {TagSchema} from 'constants/RegistryConstants';
import {graphQLToREST} from 'graphql-client/declarative-translations/external/translate';

import {TagSchemaGraphQL} from '../../../../graphql-fragments/schemas/tag-schemas/__generated/TagSchemaGraphQL';
import {TagSchemaValidationErrorLabelSummaryGraphQL} from '../../../../graphql-fragments/schemas/tag-schemas/__generated/TagSchemaValidationErrorLabelSummaryGraphQL';
import {TagSchemaValidationStatusSummaryGraphQL} from '../../../../graphql-fragments/schemas/tag-schemas/__generated/TagSchemaValidationStatusSummaryGraphQL';

type ValidationStatusSummaryGraphQL = TagSchemaValidationStatusSummaryGraphQL['validationStatusSummary'];
type ValidationErrorLabelSummaryGraphQL =
  TagSchemaValidationErrorLabelSummaryGraphQL['validationErrorLabelSummary'];

type TagSchemaWithStatusSummaryGraphQL = TagSchemaGraphQL & {
  validationStatusSummary: ValidationStatusSummaryGraphQL | null;
};
type TagSchemaWithErrorLabelSummaryGraphQL = TagSchemaGraphQL & {
  validationErrorLabelSummary: ValidationErrorLabelSummaryGraphQL | null;
};

export interface ValidationStatusSummary {
  numFailed: number;
  numPassed: number;
  numOverridden: number;
  numValidating: number;
}

export interface ValidationErrorLabelSummary {
  numConstraintViolation: number;
  numMissingRequired: number;
  numInvalidLink: number;
  numInvalidMultipleLink: number;
  numInvalidValue: number;
  numOther: number;
}

export interface ItemWithValidationStatusSummary {
  id: string;
  validationStatusSummary: ValidationStatusSummary | null;
}

export interface ItemWithValidationErrorLabelSummary {
  id: string;
  validationErrorLabelSummary: ValidationErrorLabelSummary | null;
}

export interface TagSchemaWithValidationStatusSummary extends TagSchema, ItemWithValidationStatusSummary {}

export interface TagSchemaWithValidationSummaries
  extends TagSchemaWithValidationStatusSummary, ItemWithValidationErrorLabelSummary {}

export function gqlTagSchemaWithStatusSummaryToREST(
  queryTagSchema: TagSchemaWithStatusSummaryGraphQL
): TagSchemaWithValidationStatusSummary {
  const tagSchema = graphQLToREST('TagSchema', queryTagSchema);
  return {
    ...tagSchema,
    validationStatusSummary: queryTagSchema.validationStatusSummary,
  };
}

export function gqlTagSchemaWithValidationSummariesToREST(
  queryTagSchema: TagSchemaWithErrorLabelSummaryGraphQL & TagSchemaWithStatusSummaryGraphQL
): TagSchemaWithValidationSummaries {
  const tagSchemaWithStatusSummary = gqlTagSchemaWithStatusSummaryToREST(queryTagSchema);
  return {
    ...tagSchemaWithStatusSummary,
    validationErrorLabelSummary: queryTagSchema.validationErrorLabelSummary,
  };
}
